function recursivelyFindResourceById(resources, resourceId) {
  for (const resource of resources) {
    if (resource.kind === "Group") {
      if (resource.children) {
        const nestedMatch = recursivelyFindResourceById(
          resource.children,
          resourceId
        );
        if (nestedMatch) {
          return nestedMatch;
        }
      }
    } else if (resource.id === resourceId) {
      return resource;
    }
  }
}

export { recursivelyFindResourceById };
//# sourceMappingURL=resource.find-by-id.js.map
